import React from 'react';
import PropTypes from 'prop-types';
import './Select.scss';

const Select = ({ options = [], onCheck, checked = '' }) => (
  <div className="select-container">
    <select className="select" onChange={onCheck} value={checked}>
      {!!options && options.map(({ key, value }) => <option key={key} value={key}>{value}</option>)}
    </select>
  </div>
);

Select.propTypes = {
  options: PropTypes.array.isRequired,
  onCheck: PropTypes.func.isRequired,
  checked: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Select;
